import React from 'react';
import { Link } from 'react-router-dom';
import Icon from './Icon';

/** SectionHead — eyebrow + serif title (+ subtitle) with an optional "View All" action. */
export default function SectionHead({ eyebrow, title, subtitle, action, align = 'left', as: Tag = 'h2', className = '' }) {
  return (
    <div className={`section-head section-head--${align}${className ? ` ${className}` : ''}`}>
      <div className="section-head__text">
        {eyebrow && <span className="eyebrow">{eyebrow}</span>}
        <Tag className="h-section section-head__title">{title}</Tag>
        {subtitle && <p className="section-head__sub">{subtitle}</p>}
      </div>
      {action && (
        action.to ? (
          <Link to={action.to} className="link-arrow section-head__action">{action.label}<Icon name="arrow-right" size={16} /></Link>
        ) : (
          <button type="button" onClick={action.onClick} className="link-arrow section-head__action">{action.label}<Icon name="arrow-right" size={16} /></button>
        )
      )}
    </div>
  );
}
